import { mergeMap } from "rxjs"
import { combineEpics, ofType } from "redux-observable"
import { ACTION_TYPES } from "../actions"
import { Service } from "../service"
import { ProductAction } from "../../../product/actions"

export const patchEpic = (action$) => action$.pipe(
    ofType(ACTION_TYPES.PATCH),
    mergeMap(({id, payload}) => {
        return Service.patch(id, payload).then(res => {
            return ProductAction.setInventoryData(res)
        })
    }
    )
)

export const InventoryDataEpics = combineEpics(patchEpic)


// WEBPACK FOOTER //
// ./src/state/inventory/data/epics/epics.ts